import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import EquipmentPage from './EquipmentPage';
import PartsPage from './PartsPage';
import UnitesMesurePage from './UnitesMesurePage';
import MarquesFabricantsPage from './MarquesFabricantsPage';
import AttributsPage from './AttributsPage';
import ClassificationDouanierePage from './ClassificationDouanierePage';
import CycleViePage from './CycleViePage';
import VariantesPage from './VariantesPage';
import ArticleChangelogPage from './ArticleChangelogPage';
import CostMethodsPage from './CostMethodsPage';
import PriceListsPage from './PriceListsPage';
import SubstitutsEquivalentsPage from './SubstitutsEquivalentsPage';
import ArticlesAnalysesRapportsPage from './ArticlesAnalysesRapportsPage';
import ArticlesConfigPage from './ArticlesConfigPage';
import ArticlesDashboardPage from './ArticlesDashboardPage';

const ArticlesMainPage = () => (
  <Routes>
    <Route path="equipements" element={<EquipmentPage />} />
    <Route path="pieces-detachees" element={<PartsPage />} />
    <Route path="unites-mesure" element={<UnitesMesurePage />} />
    <Route path="marques-fabricants" element={<MarquesFabricantsPage />} />
    <Route path="attributs" element={<AttributsPage />} />
    <Route path="codes-barres" element={<Navigate to="/articles/dashboard" replace />} />
    <Route path="classification-douaniere" element={<ClassificationDouanierePage />} />
    <Route path="cycle-vie" element={<CycleViePage />} />
    <Route path="variantes" element={<VariantesPage />} />
    <Route path="changelog" element={<ArticleChangelogPage />} />
    <Route path="cost-methods" element={<CostMethodsPage />} />
    <Route path="price-lists" element={<PriceListsPage />} />
    <Route path="substituts-equivalents" element={<SubstitutsEquivalentsPage />} />
    <Route path="dashboard" element={<ArticlesDashboardPage />} />
    <Route path="analyses-rapports" element={<ArticlesAnalysesRapportsPage />} />
    <Route path="config" element={<ArticlesConfigPage />} />
    <Route index element={<Navigate to="/articles/dashboard" replace />} />
  </Routes>
);

export default ArticlesMainPage;
